import React, { FormEvent, useContext, useEffect, useState } from "react";
import { PatternFormat} from 'react-number-format';
import { Checkbox, notification, Radio } from "antd";
import axios from "axios";

import { FieldSetContainer, FormContainer, Input } from "./style";

import { ChannelContext } from "../../../context/channel";
import { API_URL } from "../../../settings";
import { subscribeApi } from "../../../api/SubscribeApi";

import {t} from 'i18next';
import i18n from 'i18next';
import { Trans } from "react-i18next";
import { storage } from "../../../utils/Storage";
import { isValidCnpj, isValidCpf, isValidEmail, linkify } from "../../../utils/helper";
import Button from "../../shared/button/Button";
import { IField } from "../../../interfaces/university/form";
import { Select } from "../../shared/InputSelect/style";

interface SubscriptionFormProps {
  data: any;
  fields: IField[];
  slug: string;
  userName: string;
  is_group_only?: boolean;
  groupName?: string;
  ticket_price: number;
  type: "group" | "talk" | "event" | "course";
  is_public: boolean;
  setToggleModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const checkEmail = (email: string) => {
  if (
    email !== null &&
    email.trim() !== "" &&
    email.length >= 6 &&
    email.includes("@") &&
    isValidEmail(email)
  ) {
    return true;
  } 
  return false;
}

export const SubscriptionForm = ({
    data,
    fields,
    slug,
    userName,
    type,
    setToggleModal,
    setSuccessModal,
    is_group_only,
    groupName,
    ticket_price,
  } : SubscriptionFormProps) => {
  const {user} = useContext(ChannelContext);
  
  const [privacyPolicyAcceptance, setPrivacyPolicyAcceptance] = useState<boolean>(false);
  const [enableButton, setEnableButton] = useState<boolean>(false);
  const [secondPartSubscription, setSecondPartSubscription] = useState<boolean>(false);
  const [values, setValues] = useState<any>({email: ""});
  const [parentFields, setParentFields] = useState<IField[]>();
  const [hasAccessCode, setHasAccessCode] = useState<boolean>(false);

  useEffect(() => {
    let parentValues :string[] = [];
    let updatedValues = values;
    for (let i=0; i<fields.length; i++) {
      updatedValues = { ...updatedValues, [fields[i].name]: "" };
      let dependent = fields[i].dependent;
      if (dependent && dependent.field)
        parentValues.push(dependent.field);
    }

    setValues(updatedValues);
    setParentFields(fields.filter(filter => parentValues.includes(filter.name)));
  }, [])

  useEffect(() => {

    const emailInput = document.getElementById("email-input") as HTMLInputElement;
    
    if(emailInput) {
      if(user){
        setValues({...values, email: user.email});
      }
      emailInput.focus();
    }

  }, [fields]);

  const handleEnableButton = (policy: boolean, newValues: any) => {

    if(fields.length === 0 && !secondPartSubscription && checkEmail(newValues.email)) {
      setEnableButton(true);
    }
    else if(fields.length === 0 && ticket_price > 0 && checkEmail(newValues.email)) {
      setEnableButton(true);
    }
    else if(fields.length === 0 && secondPartSubscription && policy && checkEmail(newValues.email)) {
      setEnableButton(true);
    }
    else if(fields.length > 0 && !secondPartSubscription && checkEmail(newValues.email)){
      setEnableButton(true);
    }
    else if(fields.length > 0 && secondPartSubscription && policy && checkEmail(newValues.email)){
      setEnableButton(true);
    }
    else {
      setEnableButton(false);
    }
  }

  // submite subscribe to api
  const submitSubscribe = async () => {
    const response = await subscribeApi.subscribe(values["email"], userName, slug, values, type);

    console.log(response);

    if(response.status === 200) {
      storage.set(`is_subscribed_${userName}_${type}_${slug}`,  values.email);
      setToggleModal(false);
      setSuccessModal(true);
    }
    else if (response.status === 401 && response.data.code === 1) {
        const updatedValues = {...values, access_code: ""}
        setValues(updatedValues);
        setHasAccessCode(true);
        handleEnableButton(privacyPolicyAcceptance, updatedValues);
    }
    else {
      notification.error({
        message: t('formSubscribe.error.subscribe'),
        description: response.data.message,
      });
    }
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if(!secondPartSubscription){

      const response = await subscribeApi.guessUserInfo(
        values.email, 
        userName, 
        slug,
        type);

      // email already subscribed, can confirm
      if(response.data.is_subscribed) {
        storage.set(`is_subscribed_${userName}_${type}_${slug}`,  values.email);
        setToggleModal(false);
        setSuccessModal(true);
        return;
      }

      // redirect to eventials checkout if talk|group is paid
      else if(ticket_price > 0) {
        window.location.href = `${API_URL}/buy/${type}/${userName}/${slug}/`;
      }

      else {
        setSecondPartSubscription(true);
        setEnableButton(false);
      }
    }
    else {
       if(checkValidInputs()) {
        submitSubscribe();
      }
    }
  }

  const checkValidInputs = () => {
    let allowSubmit = true;

      fields && fields.forEach(field => {

        if(field.type === "cpf" && field.required && !isValidCpf(values[field.name] as string)){
          notification.error({
            message: t('formSubscribe.error.invalidInput', {input: 'CPF'}),
          });
          allowSubmit = false;
        }
        if(field.type === "cnpj" && field.required && !isValidCnpj(values[field.name] as string)){
          notification.error({
            message: t('formSubscribe.error.invalidInput', {input: 'CNPJ'}),
          });
          allowSubmit = false;
        }
        if(field.type === "cpf-cpnj" && field.required && 
        (!isValidCpf(values[field.name] as string) && !isValidCnpj(values[field.name] as string))){
          notification.error({
            message: t('formSubscribe.error.invalidInput', {input: 'CPF ou CNPJ'}),
          });
          allowSubmit = false;
        }
        if(field.type === "cep" && field.required && !values[field.name]){
          notification.error({
            message: t('formSubscribe.error.invalidInput', {input: 'CEP'}),
          });
          allowSubmit = false;
        }
      });

      return allowSubmit;
  }

  const handleChangeValues = (fieldName: string, fieldValue: any) => {
    const updatedValues = { ...values, [fieldName]: fieldValue };
    setValues(updatedValues);
    handleEnableButton(privacyPolicyAcceptance, updatedValues);
  }

  // update address fields using cep api
  const handleFillAddressFields = (value: string) => {
      let match = value.match(/\d+/g);
      
      if(match){
        const cep = match.join("");
  
        axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(
            (response: any) => {
              const data = response.data;

              const updatedValues = { ...values, 
                "address_address": data.logradouro,
                "address_complement": data.complemento,
                "address_neighborhood": data.bairro, 
                "address_city": data.localidade,
                "address_state": data.uf
              };

              setValues(updatedValues);
            }
          )
          .catch(function(err) {
            console.log(err);
          });
      }
  };

  const generateFieldSet = (field: IField) => {
    const lng = i18n.language;
    
    let parent;
    if (field.dependent)
      parent = parentFields?.find(parent => parent.name === field.dependent?.field)

    switch(lng){
      case 'en-US':
        field.placeholder = field.placeholder_en || "";
        field.label = field.label_en || "";
        break;
      case 'es':
        field.placeholder = field.placeholder_es || "";
        field.label = field.label_es || "";
        break;
      case 'pt-BR':
      default:
        field.placeholder = field.placeholder_pt_br || field.placeholder || "";
        field.label = field.label_pt_br || field.label || "";
        break;
    }

    switch (field.type) {
      case "phone":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="(##) #####-####"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "textarea":
        return (
          <div key={field.name}>
            <textarea
              className = "field text-area"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "radio":
        return (
          <div key={field.name}>
            <Radio
              name={field.name}
              onClick={(e) => handleChangeValues(field.name, !values[field.name])}
              checked={values[field.name]}
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
              children={<label htmlFor={`radio_${field.name}`}>{field.label}</label>}
            />
          </div>
        );
      case "checkbox":
        return (
          <div key={field.name}>
            <Checkbox
              name={field.name}
              onClick={(e) => handleChangeValues(field.name, !values[field.name])}
              checked={values[field.name]}
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
              children={<label htmlFor={`checkbox_${field.name}`}>{field.label}</label>}
            />
          </div>
        );
      case "label":
        values[field.name] = field.label;
        return (
          <div key={field.name}>
            <label htmlFor={field.name}>{field.label}</label>
          </div>
        );
      case "select":
        let optionsParse = field.label.split(";");

        type OptionType = {
          value: string,
          label: string,
        }

        const jsonOptions = optionsParse.reduce((options: OptionType[], opt) => {
          let option: OptionType;

          try {
            option = JSON.parse(opt);
            option.label = option.label.trim();
            option.value = option.value.trim();
            options.push(option);
          } catch (err) {
            console.warn("generateSelect got an JSON.parse issue");
          }

          return options;
        }, []);

        const options = jsonOptions.map((option: OptionType) => {
          return (
            <option
              key={field.name + option.value + option.label}
              value={option.value}
            >
              {option.label}
            </option>
          )
      });

        return (
          <Select
            key={field.name}
            name={field.name}
            defaultValue={field.default}
            onChange={(e) => handleChangeValues(field.name, e.target.value)}
            disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
          >
            {options}
          </Select>
        );
      case "cpf":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="###.###.###-##"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "cnpj":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="##.###.###/####-##"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "cep":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              onBlur={(e) => handleFillAddressFields(e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="#####-###"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
              />
          </div>
        );
      case "cpf-cnpj":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="##############"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "date":
        return (
          <div key={field.name}>
            <PatternFormat
              className = "field"
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name] }
              defaultValue={field.default}
              placeholder={field.placeholder || field.label}
              required={field.required}
              format="##/##/####"
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
      case "privacy_policy":
        return;
      case "password":
      case "number":
      case "text":
      default:
        return (
          <div key={field.name}>
            <Input
              name={field.name}
              onChange={(e) => handleChangeValues(field.name, e.target.value)}
              value={values[field.name]}
              placeholder={field.placeholder || field.label}
              required={field.required}
              type={type}
              autoComplete="off"
              disabled={parent && parent.type !== "select" ? field.dependent && values[field.dependent.field] === "" : field.dependent && values[field.dependent.field] !== field.name}
            />
          </div>
        );
    }
  }

  // concat privacy policy to eventials privacy policy
  const getPrivacyPolicyTerm = () => {
    let terms = "";

    fields.forEach(field => {
      if(field.type === "privacy_policy"){
        terms += field.label;
      }
    });

    return linkify(terms);
  }

  const handleUpdatePrivacyPolicy = () => {
    setPrivacyPolicyAcceptance(!privacyPolicyAcceptance);

    fields.forEach(field => {
      if(field.type === "privacy_policy") {
        values[field.name] = !privacyPolicyAcceptance;
      }
    });

    handleEnableButton(!privacyPolicyAcceptance, values);
  }

  return (
    <FormContainer onSubmit={(e) => {e.preventDefault()}} color={data.config.colors.colorPrimary}>
      {
      is_group_only && (
        <span>
          {t('formSubscribe.isGroupOnly', {groupName: groupName})}
        </span>
      )}
      <Input 
        id="email-input"
        name="email"  
        placeholder='E-mail'
        onInput={(e: any) => handleChangeValues('email', e.target.value)}
        value={values.email}
        required
      />
      <FieldSetContainer fieldsVisible={secondPartSubscription}>
        {fields.map(field => generateFieldSet(field))}
        
        {hasAccessCode && (
          <Input 
            id="acces-code-input"
            name="access_code"  
            placeholder={t('acessCode')!}
            onInput={(e: any) => handleChangeValues('access_code', e.target.value)}
            value={values.access_code}
            required
          />
        )}
        <Checkbox
          checked={privacyPolicyAcceptance}
          onClick={() => {
            handleUpdatePrivacyPolicy();
          }}
          children={
            <span>
              <Trans i18nKey={'formSubscribe.privacyPolicies'}>
                Concordo com os
                <a target="_blank" rel="noreferrer" href="https://docs.google.com/a/eventials.com/viewer?embedded=true&url=https://contratos.eventials.com/Eventials-Termos_Gerais_de_Uso-v1.pdf"> Termos de Uso</a> e 
                <a target="_blank" rel="noreferrer" href="https://www.eventials.com/portal-de-privacidade/"> Política de Privacidade</a>
              </Trans>
              {getPrivacyPolicyTerm()}
            </span>
          }
        />
      </FieldSetContainer>
      <Button
        type="submit"
        enable={enableButton}
        onClick={handleSubmit}
        size="medium"
        typographyType="button3"
        customBackground={data.config.colors.colorPrimary}
        style={{borderRadius: "30px", marginTop: "16px"}}
      >
        {t('continue')}
      </Button>
    </FormContainer>
  );
}